import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import t, { Trans } from 'translations';

export default class LiveChatMock extends Component {
    static propTypes = {
        activate: PropTypes.func.isRequired,
    };

    render() {
        return (
            <button className="livechat-mock" onClick={ this.props.activate }>
                <div className="livechat-mock--icon-wrapper">
                    <Icon symbol="speech" size="small"/>
                </div>
                <label className="u-reset livechat-mock--label">
                    { t('chatwidget.label')}
                </label>
                <label className="livechat-mock--label livechat-mock--label__mobile">
                    <Trans path='chatwidget.label_mobile' />
                </label>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/livechat/livechat-mock/index.js